import { render } from "./mainLayout.vue?vue&type=template&id=ab6c0460"
import script from "./mainLayout.vue?vue&type=script&lang=js"
export * from "./mainLayout.vue?vue&type=script&lang=js"

import exportComponent from "D:\\All Sites\\Trial Sites\\vue_13\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__